import container from 'src/components/Container';
import store from 'src/store';

export { store };

export default container;